/**
 * 获取登录信息等固定数据
 */
let allButtonJson = JSON.parse(localStorage.getItem('allbutton')) || ''

export default {allButtonJson}



// WEBPACK FOOTER //
// ./src/common/store/index.js